<template>
  <div>
    <table class="w-full mt-4 text-xs">
      <thead>
        <tr>
          <th class="pl-10px text-left text-xs w-3/10">Habit</th>
          <th
            v-for="(day, i) in days"
            :key="i"
            class="text-center text-xs w-1/10"
            :class="isToday(day.id) ? 'today' : ''"
            @click="showDateAsNumbers = !showDateAsNumbers"
          >
            {{ showDateAsNumbers ? formatDateAsNumber(day) : day.letter }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(habit, j) in habitsArray" :key="j">
          <td
            class="w-3/10 td-first cursor-pointer"
            @click="goToMonthView(habit)"
          >
            {{ habit.name }}
          </td>
          <td
            v-for="(day, i) in days"
            :key="i"
            class="text-center w-1/10 leading-normal"
            :class="{
              today: isToday(day.id),
              selected:
                selectedHabitAndDay === habit.id + day.id && sheetVisible
            }"
            @click="selectHabitAndDay(habit.id, day.id)"
          >
            <div
              v-if="logIsCompleteWithNotes(habit.id, day.id)"
              class="flex items-center justify-center"
            >
              <i
                v-if="habit.isPositive"
                @click="setAction(habit, day, i)"
                class="material-icons"
                >playlist_add_check</i
              >
              <negative-with-notes-icon
                v-else
                @click="setAction(habit, day, i)"
                class="w-24px"
              />
            </div>

            <div
              v-else-if="logIsComplete(habit.id, day.id)"
              class="flex items-center justify-center"
            >
              <i
                v-if="habit.isPositive"
                @click="setAction(habit, day, i)"
                class="material-icons"
                >done</i
              >
              <i v-else @click="setAction(habit, day, i)" class="material-icons"
                >clear</i
              >
            </div>

            <i
              v-else-if="logHasNotes(habit.id, day.id)"
              @click="setAction(habit, day, i)"
              class="material-icons"
              >subject</i
            >
            <span
              v-else
              @click="setAction(habit, day, i)"
              class="text-gray-400"
              :class="{ today: isToday(day.id) }"
              >•</span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <mt-actionsheet
      :actions="actions"
      v-model="sheetVisible"
      cancelText="Cancel"
    >
    </mt-actionsheet>
  </div>
</template>

<script>
import moment from 'moment/src/moment'
import categoryModule from '@/store/modules/category.module'
import habitModule from '@/store/modules/habit.module'
import trackerModule from '@/store/modules/tracker.module'
import logModule from '@/store/modules/log.module'
import { habitsCollection, logsCollection } from '../firebase'
import { v4 as uuidv4 } from 'uuid'
import NegativeWithNotesIcon from '@/assets/icons/NegativeWithNotesIcon'

export default {
  name: 'TrackerWeekView',
  components: { NegativeWithNotesIcon },
  props: ['habits', 'days'],

  data: () => ({
    actions: [
      { name: '', method: null },
      { name: '', method: null }
    ],
    selectedHabitAndDay: '',
    sheetVisible: false,
    showDateAsNumbers: false
  }),

  computed: {
    selectedHabit: habitModule.selectedHabit,
    monthView: trackerModule.monthView,
    selectedCategory: categoryModule.selectedCategory,
    filteredHabits: habitModule.filteredHabits,
    logs: logModule.logs,

    habitsArray() {
      if (this.selectedCategory === 'All Habits') {
        return this.habits
      }

      return this.filteredHabits
    }
  },

  methods: {
    goToMonthView(habit) {
      this.selectedHabit = habit
      this.selectedCategory = habit.category
      this.monthView = true
    },

    formatDateAsNumber(day) {
      return day.date.split('/')[1]
    },

    getLog(habitId, day) {
      return this.logs.find(
        log => log.habitId === habitId && log.weekday === day
      )
    },

    getLogIndex(habitId, day) {
      return this.logs.findIndex(
        log => log.habitId === habitId && log.weekday === day
      )
    },

    logIsCompleteWithNotes(habitId, day) {
      const log = this.getLog(habitId, day)
      if (!log) return false

      const logHasNotes = log.notes.length > 0
      const logIsComplete = log.isComplete

      return logHasNotes && logIsComplete
    },

    logIsComplete(habitId, day) {
      const log = this.getLog(habitId, day)
      if (!log) return false

      return log.isComplete
    },

    logHasNotes(habitId, day) {
      const log = this.getLog(habitId, day)
      if (!log) return false

      return log.notes.length > 0
    },

    setAction(habit, day, index) {
      let log = this.getLog(habit.id, day.id)
      let logId
      const year = this.days[index].year
      const week = this.days[index].week
      const momentObj = moment()
        .year(year)
        .week(week)
        .day(day.id)
      const month = momentObj.month()
      const date = momentObj.date()
      if (!log) {
        log = {
          habitId: habit.id,
          isComplete: false,
          notes: '',
          date,
          month,
          week,
          weekday: day.id,
          year
        }
        logId = uuidv4()
      } else {
        logId = log.id
      }

      this.sheetVisible = true

      const toggleResult = this.logIsComplete(habit.id, day.id)
        ? 'Incomplete'
        : 'Complete'
      this.actions[0].name = 'Toggle to ' + toggleResult
      this.actions[0].method = () => {
        this.sheetVisible = false
        log.isComplete = !log.isComplete
        this.$store.dispatch('setLog', { logId, log })
      }

      const noteVerb = this.logHasNotes(habit.id, day.id) ? 'Edit' : 'Add'
      const logIndex = this.getLogIndex(habit.id, day.id)
      this.actions[1].name = noteVerb + ' Note'
      this.actions[1].method = () => {
        this.$router.push({
          name: 'habit',
          params: { habit, day, log, logIndex }
        })
      }
    },

    isToday(day) {
      return day === moment().day()
    },

    selectHabitAndDay(habitId, dayId) {
      this.selectedHabitAndDay = habitId + dayId
    }
  },

  mounted() {
    logModule.getLogsForWeek()
  }
}
</script>

<style lang="scss" scoped>
.td-first {
  padding: 6px 10px;
}
tbody > tr:nth-child(odd) {
  background: #f9f9f9;
}
.today {
  color: rgb(31, 116, 255);
}
.selected {
  background-color: rgb(255, 186, 0);
  span {
    color: white;
  }
  i {
    color: white;
  }
}
.pl-10px {
  padding-left: 10px;
}
.w-24px {
  width: 24px;
}
</style>
